var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 3.33317H11.3337V0.666504H2.00033C1.26699 0.666504 0.666992 1.2665 0.666992 1.99984V9.33317H2.00033C2.00033 10.4398 2.89366 11.3332 4.00033 11.3332C5.10699 11.3332 6.00033 10.4398 6.00033 9.33317H10.0003C10.0003 10.4398 10.8937 11.3332 12.0003 11.3332C13.107 11.3332 14.0003 10.4398 14.0003 9.33317H15.3337V5.99984L13.3337 3.33317ZM4.00033 10.3332C3.44699 10.3332 3.00033 9.8865 3.00033 9.33317C3.00033 8.77984 3.44699 8.33317 4.00033 8.33317C4.55366 8.33317 5.00033 8.77984 5.00033 9.33317C5.00033 9.8865 4.55366 10.3332 4.00033 10.3332ZM13.0003 4.33317L14.307 5.99984H11.3337V4.33317H13.0003ZM12.0003 10.3332C11.447 10.3332 11.0003 9.8865 11.0003 9.33317C11.0003 8.77984 11.447 8.33317 12.0003 8.33317C12.5537 8.33317 13.0003 8.77984 13.0003 9.33317C13.0003 9.8865 12.5537 10.3332 12.0003 10.3332Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTruck);
export default __webpack_public_path__ + "static/media/white_truck.7cff0dffbd2d29590d7111c42be5b896.svg";
export { ForwardRef as ReactComponent };